export enum Roles {
  User = 'User',
  AccountingUser = 'AccountingUser',
  Manager = 'Manager',
  Admin = 'Admin',
}
